<h5 mat-dialog-title>{{ guideTitle }}</h5>

<mat-dialog-content class="guide-dialog">
    <div [innerHTML]="htmlContent"></div>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">Close</button>
</mat-dialog-actions>
